import { Component, inject } from '@angular/core';
import { ProcessService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProcessCreateDto,
  ProcessDto,
  ProcessExcelDownloadDto,
  ProcessUpdateDto,
} from '../proxy/controlling/dtos/process';
import { PROCESS_CONFIG, PROCESS_FIELDS } from './process.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-process',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ProcessService, ConfirmationService],
  templateUrl: './process.html',
  styleUrl: './process.scss',
})
export class Process extends BaseCrudComponent<
  ProcessDto,
  ProcessCreateDto,
  ProcessUpdateDto,
  ProcessExcelDownloadDto
> {
  service = inject(ProcessService);
  config = PROCESS_CONFIG;
  fields = PROCESS_FIELDS;

  protected prepareUpdateDto(data: any, selected: ProcessDto): ProcessUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Process';
  }
}
